import { ClaimsService } from './claims'
import { CPTService } from './cpt'
import { EligibilityService } from './eligibility'

const BASE_URL = (window as any).runtimeConfig?.apiURL

export const cptService = new CPTService(BASE_URL + '/public')
export const claimsService = new ClaimsService(BASE_URL)
export const eligibilityService = new EligibilityService(BASE_URL)
